import React from "react";
import CodeInput from "../components/CodeInput";

interface EmailVerificationProps {
  email: string;
  onSubmit: (code: string) => void;
  onResend: () => void;
  onBack: () => void;
  loading: boolean;
  error: string | null;
}

export default function EmailVerification({
  email,
  onSubmit,
  onResend,
  onBack,
  loading,
  error,
}: EmailVerificationProps) {
  return (
    <div>
      <button
        type="button"
        onClick={onBack}
        className="btn btn-link p-0 mb-4 text-muted d-flex align-items-center gap-1"
        aria-label="Go back"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
        Back
      </button>

      <h1 className="h3 fw-bold text-dark mb-1">Check your email</h1>
      <p className="text-muted mb-4">
        If an account exists for <strong>{email}</strong>, we&apos;ve sent a
        6-digit verification code. Enter it below to continue.
      </p>

      {error && (
        <div className="alert alert-danger py-2 mb-3" role="alert">
          {error}
        </div>
      )}

      <div className="mb-4">
        <CodeInput onComplete={onSubmit} disabled={loading} error={undefined} />
      </div>

      {loading && (
        <div className="text-center mb-3">
          <span
            className="spinner-border spinner-border-sm text-primary"
            role="status"
            aria-live="polite"
          >
            <span className="visually-hidden">Verifying code...</span>
          </span>
        </div>
      )}

      <p className="text-center text-muted small mb-0">
        Didn&apos;t receive a code?{" "}
        <button
          type="button"
          className="btn btn-link p-0 small"
          onClick={onResend}
          disabled={loading}
        >
          Resend code
        </button>
      </p>
    </div>
  );
}
